import { createStore } from "vuex";
import loginModule from "@/store/loginModule";
import companiesModule from "@/store/companiesModule";
import usersModule from "./usersModule";
import disciplinesModule from "./disciplinesModule";
import createPersistedState from "vuex-persistedstate";
import adminModule from "./adminModule";
import disciplineTagsModule from "./disciplineTagsModule";
import disciplineTopicsModule from "./disciplineTopicsModule";
import materialItemsModule from "./materialItemsModule";
import materialsModule from "./materialsModule";
import logoutModule from "./logoutModule";
import quizzesModule from "./quizzesModule";
import feedbacksModule from "./feedbacksModule";
import questionOptionsModule from "./questionsModule";
import attemptModule from "./attemptModule";
import disciplineInscriptionModule from "./disciplineInscriptionModule";
import loadingModule from "@/store/loadingModule.js";
import ltiConsumersModule from "./ltiConsumersModule";
import consumerDisciplinesModule from "./consumerDisciplinesModule";
import consumersModule from "./consumersModule";
import consumerSettingsModule from "./consumerSettingsModule";
import suppliersModule from "./suppliersModule";
import gradesModule from "./gradesModule";
import toastfyNotificationModule from "@/store/toastfyNotificationModule";
import acessibilityModule from "@/store/AcessibilityModule";
import alertsModule from "@/store/AlertsModule";
import scrollToTopModule from "@/store/scrollToTopModule";
import EventsModule from "@/store/EventsModule";
import ModalManagementModule from "./ModalManagementModule";
import SelectManagementModule from "./SelectManagementModule";
import ColorPickerModule from "./ColorPickerModule";
import ForumModule from "./ForumModule";
import audioPlayerModule from "./AudioPlayerModule";
import ProfileModule from "./ProfileModule";
import NotificationModule from "./NotificationModule";
import skeletonModule from "./skeletonModule";
import userAlertCriterionModule from "./userAlertCriterionModule";
import SocialChatModule from "./SocialChatModule";
import coursesModule from "./coursesModule";
import periodsModule from "./periodsModule";
import curriculaModule from "./curriculaModule";
import enrollmentsModule from "./enrollmentsModule";
import contactsValidationModule from "./contactsValidationModule";
import smtpSettingsModule from "./smtpSettingsModule";
import organizationsModule from "./organizationsModule";
import classroomsModule from "./classroomsModule";
import paymentPlansModule from "./paymentPlansModule";
import bankAccountsModule from "./bankAccountsModule";
import paymentMethodsModule from "./paymentMethodsModule";
import installmentsModule from "./installmentsModule";

export default createStore({
  modules: {
    login: loginModule,
    companies: companiesModule,
    users: usersModule,
    disciplines: disciplinesModule,
    disciplineTags: disciplineTagsModule,
    disciplineTopics: disciplineTopicsModule,
    material: materialsModule,
    materialItem: materialItemsModule,
    admin: adminModule,
    logout: logoutModule,
    quizzes: quizzesModule,
    feedbacks: feedbacksModule,
    questionOptions: questionOptionsModule,
    attempt: attemptModule,
    disciplineInscription: disciplineInscriptionModule,
    loading: loadingModule,
    ltiConsumers: ltiConsumersModule,
    consumerDisciplines: consumerDisciplinesModule,
    consumers: consumersModule,
    consumerSettings: consumerSettingsModule,
    suppliers: suppliersModule,
    grades: gradesModule,
    toastfy: toastfyNotificationModule,
    acessibility: acessibilityModule,
    alerts: alertsModule,
    scrollToTop: scrollToTopModule,
    events: EventsModule,
    modalManagement: ModalManagementModule,
    selectManagement: SelectManagementModule,
    colorPickerManagement: ColorPickerModule,
    forum: ForumModule,
    audioPlayer: audioPlayerModule,
    profileModule: ProfileModule,
    notificationModule: NotificationModule,
    skeleton: skeletonModule,
    userAlertCriterion: userAlertCriterionModule,
    socialChat: SocialChatModule,
    periods: periodsModule,
    curricula: curriculaModule,
    courses: coursesModule,
    enrollments: enrollmentsModule,
    contactsValidation: contactsValidationModule,
    smtpSettings: smtpSettingsModule,
    organizations: organizationsModule,
    classrooms: classroomsModule,
    paymentPlans: paymentPlansModule,
    bankAccounts: bankAccountsModule,
    paymentMethods: paymentMethodsModule,
    installments: installmentsModule,
  },

  plugins: [createPersistedState()],
});